import { JobDates } from 'ducks/types/common-types';
import { StringAutoComplete } from 'ducks/types/type-helpers';
import { offsetTimezoneUTC } from 'utils/dates';
import { v4 as uuidv4 } from 'uuid';

export type FilterType = StringAutoComplete<keyof typeof filterOptions>;
export const filterOptions = {
  queued: 'Queued',
  starting: 'Starting',
  running: 'Running',
  succeeded: 'Succeeded',
  stopped: 'Stopped',
  failed: 'Failed',
  all: 'All',
};

export const job_dates: JobDates[] = [
  {
    range_name: 'Last 24 Hours',
    start_date: offsetTimezoneUTC(new Date(), { decrement: 1, format: 'M/D/YYYY hh:mm A', local_timezone: true }),
    finish_date: null,
    uuid: uuidv4(),
  },
  {
    range_name: 'Last 7 Days',
    start_date: offsetTimezoneUTC(new Date(), { decrement: 7, format: 'M/D/YYYY hh:mm A', local_timezone: true }),
    finish_date: null,
    uuid: uuidv4(),
  },
  {
    range_name: 'Last 30 Days',
    start_date: offsetTimezoneUTC(new Date(), { decrement: 30, format: 'M/D/YYYY hh:mm A', local_timezone: true }),
    finish_date: null,
    uuid: uuidv4(),
  },
];

export const jobQuery = {
  filter: null,
  range_name: 'Last 7 Days',
  start_date: offsetTimezoneUTC(new Date(), { decrement: 7, format: 'M/D/YYYY hh:mm A', local_timezone: true }),
  finish_date: null,
};
